<template>
    <a-button type="link" @mouseover="isMouseEnter = true" @mouseleave="isMouseEnter = false" @click="handleClick">
        <span class="link-button" :style="isMouseEnter?'border-bottom: 2px solid #f0f2f5':''">
            <slot></slot>
        </span>
    </a-button>
</template>

<script>
    export default {
        name: "LinkButton",
        data() {
            return {
                isMouseEnter: false,
            }
        },
        methods: {
            handleClick() {
                this.$emit("click")
            }
        }
    }
</script>

<style lang="less">
    .link-button {
        color: #f0f2f5;
        font-size: large;
    }
</style>
